import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import EmailResend from '../profile/EmailResend'
import ProfileForm from '../app-form/ProfileForm'

const styles = theme => ({
  emailStatus: {
    whiteSpace: 'nowrap',
    marginLeft: 10,
    padding: '1px 8px',
    fontSize: 10,
    color: 'rgb(0, 0, 0)',
    borderRadius: 10,
    backgroundColor: 'rgb(255, 204, 0)',
  },
})

class ProfileSettings extends Component {
  state = {
    user: window.state.user,
    license: window.state.license,
    last_time_login: window.state.last_time_login,
  }

  render() {
    const { user, license } = this.state
    const { classes, load, emailResend, onSubmit } = this.props

    return (
      <Fragment>
        <ul style={{ padding: 0, margin: '0 0 32px 0' }}>
          <Typography
            component="li"
            variant="h5"
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {user.email}
            <span className={classes.emailStatus}>
              {user.email_verified_at ? 'подтвержден' : 'не подтвержден'}
            </span>
          </Typography>
          <Typography component="li" variant="h5">
            {!user.email_verified_at ? user.phone : null}
          </Typography>

          {license && license.type === 'TRIAL' ? (
            <Typography
              component="li"
              style={{
                marginTop: 15,
                fontFamily: 'Caveat',
                fontSize: 16,
                color: 'rgb(136, 102, 255)',
              }}
            >
              бесплатный аккаунт
            </Typography>
          ) : null}

          {state.last_time_login ? (
            <Typography
              component="li"
              style={{
                marginTop: 15,
                fontSize: 12,
                color: 'rgba(0, 0, 0, 0.65)'
              }}
            >
              Дата последнего входа: {state.last_time_login}
            </Typography>          
          ) : (
            ''
          )}
        </ul>

        {user.email_verified_at ? (
          <ProfileForm
            onSubmit={onSubmit}
            initialValues={{ phone: user.phone }}
            isFetching={load}
          />
        ) : (
          <EmailResend user={user} send={emailResend} load={load} />
        )}
      </Fragment>
    )
  }
}

export default withStyles(styles)(ProfileSettings)
